import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

/**
 * Parses [[nav:/path|Label]] patterns in text and renders them as router Links.
 * Returns an array of React elements (text spans + Link components).
 */
export function parseNavLinks(text) {
  if (!text) return [text];

  const pattern = /\[\[nav:(\/[^\]|]+)\|([^\]]+)\]\]/g;
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = pattern.exec(text)) !== null) {
    // Add text before the match
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    // Add the nav link
    const [, path, label] = match;
    parts.push(
      <Link
        key={`nav-${match.index}`}
        to={path}
        className="inline-flex items-center gap-1 px-2 py-0.5 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded hover:bg-blue-100 dark:hover:bg-blue-900/50 transition-colors text-sm font-medium"
      >
        {label}
        <ExternalLink size={12} />
      </Link>
    );
    lastIndex = match.index + match[0].length;
  }

  // Add remaining text
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length > 0 ? parts : [text];
}

export default function KprosNavLink({ path, label }) {
  return (
    <Link
      to={path}
      className="inline-flex items-center gap-1 px-2 py-0.5 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded hover:bg-blue-100 dark:hover:bg-blue-900/50 transition-colors text-sm font-medium"
    >
      {label}
      <ExternalLink size={12} />
    </Link>
  );
}
